module.exports = __webpack_public_path__ + "img/acacia-promise.0fb8a021.webp";